import React from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Paper,
  Grid,
  Typography
} from '@material-ui/core'
import './SignUp.css'
import { useSelector, useDispatch } from 'react-redux'
import { setReferral } from 'redux/actions/'

export default function Aboutus() {
  const dispatch = useDispatch()
  const { referral } = useSelector(state => state.signup)

  const handleChange = event => {
    dispatch(
      setReferral({ ...referral, [event.target.name]: event.target.checked })
    )
  }
  return (
    <>
      <Typography variant="h2" align="center" style={{ padding: '25px 0' }}>
        How did you hear about us?
      </Typography>
      <FormGroup style={{ marginBottom: '3em' }}>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item sm={6} className="checkboxgrid">
            <Paper className="checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={referral?.OnlineAds}
                    onChange={handleChange}
                    color="primary"
                    name="OnlineAds"
                  />
                }
                label="Online Ads"
              />
            </Paper>
          </Grid>
          <Grid item sm={6} className="checkboxgrid">
            <Paper className="checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={referral?.SocialMedia}
                    onChange={handleChange}
                    color="primary"
                    name="SocialMedia"
                  />
                }
                label="Social Media"
              />
            </Paper>
          </Grid>
          <Grid item sm={6} className="checkboxgrid">
            <Paper className="checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={referral?.FriendsorFamily}
                    onChange={handleChange}
                    color="primary"
                    name="FriendsorFamily"
                  />
                }
                label="Friends or Family"
              />
            </Paper>
          </Grid>
          <Grid item sm={6} className="checkboxgrid">
            <Paper className="checkbox">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={referral?.VideoAd}
                    onChange={handleChange}
                    color="primary"
                    name="VideoAd"
                  />
                }
                label="Video Ad"
              />
            </Paper>
          </Grid>
        </Grid>
      </FormGroup>
    </>
  )
}
